import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  Tooltip,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useGet from "../../../services/hooks/useGet";
import { apiEndpoints } from "../../../shared/constants/api-constant";
import { Heading } from "../../../shared/ReusableComponents";
import { GridTable } from "../../../shared/ReusableComponents/GridTable";
import { DateFormatter } from "../../../shared/utils/DateFormatter";
import { hideLoader, showLoader } from "../../../store/currentPreferencesSlice";
import { useDispatch } from "react-redux";
import restApiService from "../../../services/restApiService";
import FileViewer from "../../../shared/ReusableComponents/FileViewer";
import { CommonFunctions } from "../../../shared/utils/CommonFunctions";

interface IDocument {
  name: string;
  content: string;
  type: "image" | "pdf";
}
function Investigation() {
  const { currentCaseId } = useParams<{ currentCaseId: string }>();
  const [originalData, setOriginalData] = React.useState<any[]>([]);
  const [file, setFile] = React.useState<IDocument | undefined>(undefined);
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);
  const { error, data, getService, loading } = useGet();

  const dispatch = useDispatch();

  useEffect(() => {
    if (error) return;
    if (!(data && originalData)) {
      getService(`${apiEndpoints.INVESTIGATIONS}/${currentCaseId}`);
    }
  }, [currentCaseId]);

  useEffect(() => {
    data && setOriginalData(data);
  }, [data]);

  useEffect(() => {
    loading ? dispatch(showLoader()) : dispatch(hideLoader());
  }, [loading]);

  const downLoadAndViewFile = async (fileUrl: string, fileName: string) => {
    setIsModelOpen(false);
    setFile(undefined);
    dispatch(showLoader());
    await restApiService.get(fileUrl).then(async (response) => {
      const fileData = await response.data.fileData;
      setFile({
        content: fileData,
        name: fileName,
        type: fileName.endsWith(".pdf") ? "pdf" : "image",
      });
      dispatch(hideLoader());
      if (fileData) setIsModelOpen(true);
    });
  };

  const renderFile = (params: any) => {
    const fileUrl = `${apiEndpoints.INVESTIGATION}/${params.row.id}`;
    return (
      <Link
        underline="always"
        sx={{ cursor: "pointer" }}
        onClick={() => downLoadAndViewFile(fileUrl, params.row.fileName)}
      >
        <Tooltip title={params.row.fileName}>{params.row.fileName}</Tooltip>
      </Link>
    );
  };

  const onModelClose = () => {
    setIsModelOpen(false);
  };

  const columns: GridColDef[] = [
    {
      field: "fileName",
      headerName: "File Name",
      renderCell: renderFile,
    },
    {
      field: "updatedOn",
      headerName: "Date Uploaded",
      valueGetter: (value, row) =>
        row.updatedOn ? DateFormatter.formatDate(row.updatedOn) : "",
    },
    {
      field: "",
      headerName: "Uploaded By",
      valueGetter: (value, row) =>
        CommonFunctions.formatFirstAndLastName(row.firstName, row.lastName),
    },
  ];

  return (
    <React.Fragment>
      <Heading
        text="Attached Files"
        type="h5"
        isBold={true}
        style={{ paddingLeft: "20px" }}
      />
      <Box sx={{ width: "550px" }}>
        <GridTable
          rows={originalData}
          isPaginationHide={true}
          columns={columns}
        />
      </Box>
      <FileViewer
        file={file}
        isModelOpen={isModelOpen}
        onModelClose={onModelClose}
        setIsModelOpen={setIsModelOpen}
      />
    </React.Fragment>
  );
}

export default Investigation;
